import React from "react";
import PropTypes from "prop-types";
import {findDOMNode} from "react-dom";

import UsersMultiselectPopoverOption from "./option-user";

export default class MultiselectPopoverOptionsSelector extends React.Component {

    static propTypes = {
        parent: PropTypes.object,
        options: PropTypes.array,
        searchString: PropTypes.string,

        keyboardNavigation: PropTypes.bool,

        onUpdateScroll: PropTypes.func,
    }

    static defaultProps = {
        keyboardNavigation: true
    }

    constructor(props) {
        super(props);

        this.state = {
            currentCursorKey: null
        };

        // references for options for keyboard navigation
        this.optionRef = {};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null;

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node);
    }

    _getOptions = () => {
        let options = this.props.options.slice();

        // filter options by search string
        let searchString = this.props.searchString;
        if (searchString) {
            searchString = searchString.toLowerCase();
            options = _(options)
                .filter(option => option.label.toLowerCase().includes(searchString))
                .value();
        }

        /*// add no value if necessary
        if (this.props.field.noValueOption) {
            options.unshift({
                value: null,
                label: this.props.field.noValueOptionLabel
            });
        }*/

        return options;
    }

    onClickOption = (option) => {this.props.parent.onOptionClick(option)}

    onChangeCursorOption = (newValue) => {
        this.setState({currentCursorKey: newValue});
    }

    onPopoverKeyDown = (event) => {
        if (!this.props.keyboardNavigation) return;

        const options = this._getOptions();

        let newValue;

        switch(event.key) {
            case 'Escape': this.props.parent.hidePopover(); break;

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0;
                }

                this.onChangeCursorOption(newValue);
                break;

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey + 1;
                    if (newValue > options.length - 1) newValue = options.length - 1;
                }

                this.onChangeCursorOption(newValue);
                break;

            case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey];
                    if (curOption) this.onClickOption(curOption);
                }
                break;
        }
    }

    render() {
        const options = this._getOptions();
        const highlightedOption = options[this.state.currentCursorKey];
        const selectedOptions = this.props.parent.state.currentOptions ? this.props.parent.state.currentOptions : [];

        return (
            <React.Fragment>
                {_.map(options, (option, key)=>
                    <UsersMultiselectPopoverOption ref={r=>this.optionRef[key] = r}
                                                   key={option.value}
                                                   option={option}
                                                   isHighlighted={highlightedOption && highlightedOption.value === option.value}
                                                   isSelected={selectedOptions.includes(option.value)}
                                                   onClick={()=>this.onClickOption(option)}/>
                )}
            </React.Fragment>
        );
    }
}